import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';

export const toolOnboardingDashboardPage = PageBlueprint.make({
  params: {
    title: 'Tool Onboarding Dashboard',
    path: '/dashboards/tool-onboarding-dashboard',
    routeRef: rootRouteRef,
    loader: () =>
      import('./pages/tool-onboarding-dashboard-page').then(m => (
        <m.ToolOnboardingDashboardPage />
      )),
  },
});

export const toolOnboardingDashboard = createFrontendPlugin({
  pluginId: 'tool-onboarding-dashboard',
  title: 'Tool Onboarding Dashboard',
  extensions: [toolOnboardingDashboardPage],
  routes: {
    root: rootRouteRef,
  },
});
